import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Card,
  Row,
  Col,
} from "antd";
import { EyeOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import paymentApi from "../api/paymentApi";
import { useDispatch } from "react-redux";
import { currencyFormat, objectToTable } from "../utils";
const LogsTransaction = (props) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const dateFormat = "DD/MM/YYYY HH:mm:ss";

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [dataTransaction, setDataTransaction] = useState("");

  const [inputFilter, setFilter] = useState({
    provider: "",
    orderCode: "",
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const [lstLogs, setLogs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    getLogs();
  }, [inputFilter]);

  const getLogs = () => {
    setLoading(true);
    paymentApi.getPaymentLog(inputFilter).then((res) => {
      if (res?.results) {
        setLogs(res?.results);
        setTotalCount(res?.totalResults);
      }
      setLoading(false);
    });
  };

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
      fixed: "left",
    },
    // {
    //   title: "OrderId",
    //   dataIndex: "orderId",
    // },
    {
      title: "Mã đơn hàng",
      dataIndex: "orderCode",
      key: "orderCode",
      render: (text) => <b>#{text}</b>,
      width: "5%",
      fixed: "left",
    },
    {
      title: "Cổng thanht toán",
      dataIndex: "provider",
    },
    {
      title: "Nội dung",
      dataIndex: "message",
      className: "whiteSpace-nowrap",
    },
    {
      title: "Địa chỉ IP",
      dataIndex: "ip",
    },

    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (amount) => <label>{currencyFormat(amount)}</label>,
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      render: (createdAt) => <>{moment(createdAt).format(dateFormat)}</>,
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            value="large"
            icon={<EyeOutlined />}
            onClick={() => viewDetails(record)}
          >
            Xem
          </Button>
        </Space>
      ),
      width: 50,
      fixed: "right",
    },
  ];

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      orderCode: inputFilter.orderCode,
      provider: inputFilter.provider,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }
  const closePopup = useCallback(() => {
    setDataTransaction({});
    setIsModalEditVisible(false);
  }, []);

  const viewDetails = (record) => {
    setTitleModal("Chi tiết transaction");
    const dataTable = objectToTable(record.data);
    setDataTransaction(dataTable.outerHTML);
    setIsModalEditVisible(true);
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6} className="ant-col-mt-10">
              <label> Mã đơn hàng</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                value={inputFilter.orderCode}
                placeholder="Nhập mã đơn hàng ..."
                onChange={(e) => {
                  setFilter({ ...inputFilter,page: 1,  orderCode: e.target.value });
                }}
                style={{
                  width: "100%",
                }}
              />
            </Col>

            <Col span={6} className="ant-col-mt-10">
              <label className="">Phương thức thanh toán</label>
              <Select
                value={inputFilter.provider}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1,  provider: e });
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value="momo">Momo</Option>
                <Option value="vnpay">Vnpay</Option>
              </Select>
            </Col>
          </Row>
        </Card>

        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <div className="table-responsive">
            <Table
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstLogs}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>
      </div>

      <Modal
        title={titleModal}
        visible={isModalEditVisible}
        onOk={() => {
          closePopup();
        }}
        width={900}
        onCancel={() => {
          closePopup();
        }}
      >
       <div
            className="table-transaction"
            dangerouslySetInnerHTML={{ __html: dataTransaction }}
          ></div>
      </Modal>
    </>
  );
};

export default LogsTransaction;
